import type { PeopleState } from './people.types';

const initialState = {
	currentTab: 0,
};

export const createPeopleStore = (
	set: (
		state:
			| Partial<PeopleState>
			| ((state: PeopleState) => Partial<PeopleState>),
	) => void,
) => ({
	...initialState,
	resetState: () => set(initialState),
	setCurrentTab: (tab: number) => set({ currentTab: tab }),
});
